import React, { Fragment } from "react";
import Titre from "../UI/Titres/TitreH1";

const  route404 = (props) => (
    <Fragment>
        <Titre>Erreur 404 !</Titre>
        <p>La page n'existe pas</p>
    </Fragment>
);
export default route404;